import React, { useState } from 'react';
import { useTranslate } from '@hooks';
import MailIcon from 'mdi-react/EmailCheckOutlineIcon';
import { ButtonFlat } from '@dotone/react-ui-core';
import MarketplaceInvitePreviewModal from '../Marketplace/MarketplaceInvitePreviewModal';

const MarketplaceInviteEmailLogModal = ({ affiliateMarketplaceInvite }) => {
  const { t } = useTranslate('affiliateMarketplaceInvite', 'hints');
  const [isOpen, setOpen] = useState(false);
  const { id, sentEmailSubject, sentEmailBody } = affiliateMarketplaceInvite;

  const handleToggle = () => {
    setOpen(!isOpen);
  };

  if (!sentEmailBody) return null;

  return (
    <>
      <ButtonFlat
        id={`marketplace-invite-email-log-${id}`}
        title={t('invitationEmailSent')}
        size="sm"
        onClick={handleToggle}
      >
        <MailIcon size={22} />
      </ButtonFlat>
      <MarketplaceInvitePreviewModal
        isOpen={isOpen}
        onToggle={handleToggle}
        data={{ subject: sentEmailSubject, html: sentEmailBody }}
      />
    </>
  );
};

export default MarketplaceInviteEmailLogModal;
